import React, { useEffect, useState } from "react";

import useHttp from "../../../hooks/use-http";

import moment from "moment";
import convertToExcel from "../../../components/ExportToExcel";
import Pagination from "../../../components/Pagination";

const VoucherPayment = () => {
  const [data, setData] = useState([]);
  const [paymentRecieptTo, setPaymentRecieptTo] = useState(0);
  const [bankCashAccount, setBankCashAccount] = useState(0);

  const [bankCashAccountData, setBankCashAccountData] = useState([]);
  const [paymentRecieptToData, setPaymentRecieptToData] = useState([]);

  const { sendRequest: getData } = useHttp();

  const loadData = (type) => {
    const accType = type;

    const setAccountData = (data, setFunction) => {
      console.log(data);
      setFunction(data);
    };

    getData(
      {
        url: `/api/voucherAccountList/?accType=${accType}&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        if (accType === "Bank/Cash") {
          setAccountData(data, setBankCashAccountData);
        } else if (accType === "Payee") {
          setAccountData(data, setPaymentRecieptToData);
        }
      }
    );
  };

  useEffect(() => {
    loadData("Payee");
    loadData("Bank/Cash");
  }, []);

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFDateChange = (e) => {
    //console.log("handleFDateChange", e.target.value);
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 15);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  //console.log("toDate", toDate);

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getReportData } = useHttp();

  const FillReport = (bankCashAccount, paymentRecieptTo) => {
    var fdate = moment(selectedFromDate).format("DD/MM/YYYY");
    var tdate = moment(selectedToDate).format("DD/MM/YYYY");
    var urlfilter = "";

    urlfilter = urlfilter + `&fromDate=${fdate}`;
    urlfilter = urlfilter + `&toDate=${tdate}`;

    if (bankCashAccount > 0) {
      urlfilter = urlfilter + `&bankCashAccount=${bankCashAccount}`;
    }

    if (paymentRecieptTo > 0) {
      urlfilter = urlfilter + `&paymentRecieptTo=${paymentRecieptTo}`;
    }

    var url = `/api/paymentVoucherReport/?orgId=${localStorage.getItem(
      "orgId"
    )}${urlfilter} `;

    getReportData(
      {
        url: url,
      },
      (data) => {
        setData(data);
      }
    );
  };

  useEffect(() => {
    FillReport(0, 0);
  }, [getReportData]);

  const fieldsToExport = [
    "bankcashAccountName",
    "bankcashCode",

    "paymentReceiptName",

    "paymentReceiptAccountName",

    "paymentReceiptAccountCode",
    "totalPaidAmount",
    "payReceiptType",
    "paymentReferenceNo",
  ];

  const customHeaders = [
    "Bank/Cash Account Name",
    "Bank/Cash Account Code",
    "Payee Name",
    "Payee Account Name",
    "Payee Account Code",
    "Paid Amount ",
    "Mode Of Payment/Receipt",
    "Payement Ref No",
  ];

  const handleExportExcel = () => {
    const filename = "VoucherPaymentReport.xlsx";

    convertToExcel(data, fieldsToExport, filename, customHeaders);
  };

  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              {" "}
              <h3>Voucher Payment Report</h3>
            </div>
            <hr />
            <div className="row"></div>
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>Bank/Cash Account</label>
                  <select
                    id="bank/cash account"
                    className="form-control"
                    value={bankCashAccount}
                    onChange={(e) => {
                      setBankCashAccount(e.target.value);
                    }}
                  >
                    <option value="">select</option>
                    {bankCashAccountData &&
                      bankCashAccountData.map((x) => (
                        <option
                          key={x.accountMappingId}
                          value={x.accountMappingId}
                        >
                          {x.mappedName + " " + x.accountName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"payment_to"}>{"Payment/Receipt To"}</label>
                  <select
                    id="payment_to"
                    className="form-control"
                    value={paymentRecieptTo}
                    onChange={(e) => {
                      setPaymentRecieptTo(e.target.value);
                    }}
                  >
                    <option value="">select</option>
                    {paymentRecieptToData &&
                      paymentRecieptToData.map((x) => (
                        <option
                          key={x.accountMappingId}
                          value={x.accountMappingId}
                        >
                          {x.mappedName + " " + x.accountName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"from_date"}>{"From Date"}</label>
                  <input
                    type={"date"}
                    id={"date"}
                    required
                    className="form-control"
                    max={currentDate}
                    value={selectedFromDate}
                    onChange={handleFDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label>{"To Date"}</label>

                  <input
                    type={"date"}
                    id={"date"}
                    required
                    className="form-control"
                    max={currentDate}
                    value={selectedToDate}
                    onChange={handleTDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      FillReport(bankCashAccount, paymentRecieptTo);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>

          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th>Bank/Cash Account Name</th>
                          <th>Bank/Cash Account Code</th>
                          <th>Payee Name</th>

                          <th>Payee Account Name</th>
                          <th>Payee Account Code</th>
                          <th>Paid Amount </th>
                          <th>Mode Of Payment/Receipt</th>
                          <th>Payement Ref No</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td>{itm.bankcashAccountName}</td>
                                <td>{itm.bankcashCode}</td>

                                <td>{itm.paymentReceiptName}</td>

                                <td>{itm.paymentReceiptAccountName}</td>

                                <td> {itm.paymentReceiptAccountCode} </td>
                                <td> {itm.totalPaidAmount} </td>
                                <td> </td>
                                <td> {itm.paymentReferenceNo} </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default VoucherPayment;
